// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1sZ-o","expandIcon":"AccordionButton_expandIcon__1KWv2","expanded":"AccordionButton_expanded__2RFHR"};